import React, { Component } from 'react';
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Progress,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import apiClient from "../util/api-client";
import iconPcAndMobile from "../ui/images/iconPc_Mobile.svg";
import iconPc from "../ui/images/iconPc.svg";
import iconMobile from "../ui/images/iconMobile.svg";
import iconMobileSmall from "../ui/images/iconMobileSmall.svg";
import IconUploadImage from 'images/upload_image.png';
import IconUploadYoutubeDrive from 'images/upload_youtube_drive.png';
import IconGDrive from 'images/nav/google-drive.png';
import IconPointer from 'images/icon_pointer.png';
import GooglePolicyModal from './GooglePolicyModal';
import GoogleOptionSelector from './GoogleOptionSelector';
import GoogleDriveVideoUploader from './GoogleDriveVideoUploader';
import GoogleDriveImageUploader from './GoogleDriveImageUploader';
import LimitDriverWithLessProPlan from './LimitDriverWithLessProPlan';
import LimitYoutubeModal from './LimitYoutubeModal';
const regex = new RegExp("^(http[s]?:\\//){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
const CAPTURE_URL_SELECT_MODAL_ID = 'capture-url-select';
const resolveModalEventId = (event) => (
  event?.detail?.modalId ||
  event?.target?.id ||
  event?.target?.querySelector?.('.modal-dialog[id]')?.id ||
  ''
);
const deviceOptions = [
  {
    icon: iconPcAndMobile,
    text: "画面サイズオプション",
    value: "",
    size: "",
    width: "43px",
    height: "24px",
  },
  {
    icon: iconPc,
    text: "デスクトップ大",
    value: "pc",
    size: "1920px",
    width: "30px",
    height: "26px",
  },
  {
    icon: iconPc,
    text: "デスクトップ中",
    value: "laptop",
    size: "1280px",
    width: "30px",
    height: "26px",
  },
  {
    icon: iconMobile,
    text: "タブレット",
    value: "tablet",
    size: "768px",
    width: "20px",
    height: "28px",
  },
  {
    icon: iconMobileSmall,
    text: "スマートフォン",
    value: "smartphone",
    size: "375px",
    width: "14px",
    height: "20px",
  },
];
export default class CaptureUrlSelectModal extends Component {
  constructor(props) {
    super(props);
    const { baseURL, hideGoogleInstruction, defaultGdriveLogic } = props;
    this.state = {
      shouldShowGooglePolicy: false,
      shouldShowOriginSelect: true,
      shouldShowGoogleOption: false,
      shouldShowDriveImageModal: false,
      shouldShowDriveVideoModal: false,
      shouldShowNoPermission: false,
      shouldShowInvalidLink: false,
      animationKind: 'image',
      completed: 0,
      showProgressBar: false,
      googleInstructionOpened: hideGoogleInstruction,
      link: '',
      deviceSelected: deviceOptions[0],
      userChoice: defaultGdriveLogic,
      taskType: null,
      shouldShowLimitDriverWithLessProPlan: false,
      shouldShowLimitYoutubeModal: false,
    }
    this.stateHistory = []
    this.apiClient = apiClient({ baseURL: baseURL || "/" });
    this.intervalId = null;
    this.modalRef = React.createRef();
  }

  calculateTime = () => {
    let intervalTime = 400;
    this.intervalId = setInterval(() => {
      const { completed } = this.state;
      if (completed < 99) {
        this.setState({ completed: completed + 1 });
      }
    }, intervalTime);
  };

  preprocess = () => {
    this.setState({ completed: 0, showProgressBar: true });
    this.calculateTime();
  };

  finishProgress = () => {
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.setState({ completed: 0, showProgressBar: false });
  };

  componentWillUnmount() {
    this.stateHistory = [];
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  isRootStep = () => {
    const {
      shouldShowGooglePolicy,
      shouldShowOriginSelect,
      shouldShowGoogleOption,
      shouldShowDriveImageModal,
      shouldShowDriveVideoModal,
      shouldShowNoPermission,
      shouldShowInvalidLink,
      shouldShowLimitDriverWithLessProPlan,
      shouldShowLimitYoutubeModal,
    } = this.state;

    return shouldShowOriginSelect &&
      !shouldShowGooglePolicy &&
      !shouldShowGoogleOption &&
      !shouldShowDriveImageModal &&
      !shouldShowDriveVideoModal &&
      !shouldShowNoPermission &&
      !shouldShowInvalidLink &&
      !shouldShowLimitDriverWithLessProPlan &&
      !shouldShowLimitYoutubeModal;
  };

  handleModalBackClick = (e) => {
    const currentModalId = resolveModalEventId(e);
    if (!this.props.isOpen || currentModalId !== CAPTURE_URL_SELECT_MODAL_ID) return;

    if (!this.isRootStep()) {
      e.preventDefault();
      this.goBack();
      return;
    }

    e.preventDefault();
    if (this.props.onClickClose) {
      this.closeModal();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);

    // Get taskType after component is mounted and DOM is fully loaded
    const uploadVersionPopup = document.getElementById('uploadVersionPopup');
    if (uploadVersionPopup) {
      this.setState({
        taskType: uploadVersionPopup.getAttribute('data-task-type')
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
      this.stateHistory = [];
    }

    // Re-create apiClient if baseURL changes (e.g., when selecting another akaire_file)
    if (prevProps.baseURL !== this.props.baseURL) {
      this.apiClient = apiClient({ baseURL: this.props.baseURL || "/" });
    }
  }

  // Save current state to history before changing state
  saveStateToHistory = () => {
    this.stateHistory.push({...this.state});
  }

  // Go back to previous state
  goBack = () => {
    const { googleInstructionOpened } = this.state
    if (this.stateHistory.length > 0) {
      const previousState = this.stateHistory.pop();
      if(googleInstructionOpened && !previousState.googleInstructionOpened){
        this.setState({
          shouldShowGooglePolicy: false,
          shouldShowOriginSelect: true,
          shouldShowGoogleOption: false,
          shouldShowDriveImageModal: false,
          shouldShowDriveVideoModal: false,
          shouldShowNoPermission: false,
          shouldShowInvalidLink: false,
          shouldShowLimitDriverWithLessProPlan: false,
          shouldShowLimitYoutubeModal: false,
          animationKind: 'image',
          link: ''
        });
      } else {
        this.setState(previousState);
      }
    } else {
      // If no history, reset to initial state
      this.setState({
        shouldShowGooglePolicy: false,
        shouldShowOriginSelect: true,
        shouldShowGoogleOption: false,
        shouldShowDriveImageModal: false,
        shouldShowDriveVideoModal: false,
        shouldShowNoPermission: false,
        shouldShowInvalidLink: false,
        shouldShowLimitDriverWithLessProPlan: false,
        shouldShowLimitYoutubeModal: false,
        animationKind: 'image',
        link: ''
      });
    }
  }

  handleClickOutside = () => {
    const { shouldShowOriginSelect } = this.state
    if(shouldShowOriginSelect) {
      this.closeModal();
    } else {
      this.goBack();
    }
  };

  handleChooseOrigin = (event, origin) => {
    event.preventDefault();
    this.saveStateToHistory();
    if(origin === 'youtube') {
      if(this.props.isFreeOrLightPlan) {
        this.setState({shouldShowLimitYoutubeModal: true})
      } else {
        this.props.onClickTransitionYoutube();
      }
    } else if(origin === 'google-image') {
      this.setState({
        shouldShowDriveImageModal: true,
        shouldShowDriveVideoModal: false,
        shouldShowOriginSelect: false,
        shouldShowGoogleOption: false,
        animationKind: 'image'
      })
    } else if(origin === 'google-video') {
      this.setState({
        shouldShowDriveImageModal: false,
        shouldShowDriveVideoModal: true,
        shouldShowOriginSelect: false,
        shouldShowGoogleOption: false,
        animationKind: 'video',
      })
    } else {
      const { canUseGoogle } = this.props;
      if(canUseGoogle) {
        const googleInstructionOpened = this.checkShowGoogleInstructionModal();
        this.setState({
          shouldShowGooglePolicy: !googleInstructionOpened,
          shouldShowOriginSelect: false,
          shouldShowGoogleOption: googleInstructionOpened
        });
      } else {
        this.setState({shouldShowLimitDriverWithLessProPlan: true})
      }
    }
  }

  checkboxChange = (event) => {
    this.hideGoogleInstruction();
    this.setState({
      googleInstructionOpened: true,
      shouldShowGooglePolicy: false,
      shouldShowOriginSelect: false,
      shouldShowGoogleOption: true,
      shouldShowDriveImageModal: false,
      shouldShowDriveVideoModal: false,
    });
  };

  closeModal = (event) => {
    const { onClickClose} = this.props;
    this.stateHistory = [];
    onClickClose();
    this.setState({
      shouldShowGooglePolicy: false,
      shouldShowOriginSelect: true,
      shouldShowGoogleOption: false,
      shouldShowDriveImageModal: false,
      shouldShowDriveVideoModal: false,
      shouldShowNoPermission: false,
      shouldShowInvalidLink: false,
      acceptTerm: false,
      animationKind: 'image',
      shouldShowLimitDriverWithLessProPlan: false,
      shouldShowLimitYoutubeModal: false,
      link: '',
    });
  };
  fromProjectId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_project_id');
  }
  fromTaskId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_task_id');
  }
  fromWorkId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_work_id');
  }
  fromPageId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_page_id');
  }
  fromAkaireFileId = () => {
    const url = new URL(location.href);
    return url.searchParams.get('from_file_id');
  }
  withNewTask = () => {
    const url = new URL(location.href);
    return url.searchParams.get('with_new_task');
  }
  withNewProject = () => {
    const url = new URL(location.href);
    return url.searchParams.get('with_new_project');
  }
  withNewFile = () => {
    return new URL(location.href).searchParams.get('with_new_file');
  }

  setUserChoice = (selectedOption) => {
    this.setState({userChoice: selectedOption.value})
  }


  handleSubmit = (event) => {
    const { onFinish, onStart } = this.props;
    const {
      link,
    } = this.state;

    const checkUploadNewPage = $('#uploadNewPagePopup').attr('data-upload-new') == 'true'
    const pageId = checkUploadNewPage ? 'new' : $('#uploadVersionPopup').attr('data-page-id')
    event.preventDefault();
    if (link) {
      this.preprocess();
      if (pageId === 'new' || pageId == undefined){
        this.uploadGoogleDrive(pageId, link, onStart)
      }else {
        this.apiClient.get(`${pageId}/check_final_version`).then((response) => {
          if(response.data.is_has_final_version){
            Popup.confirm('現在、このページには最終稿バージョンが存在します。<br>新しいバージョンをアップロードすると、最終稿が解除されます。<br>アップロードしてよろしいですか？', {
              confirmText: 'OK',
              cancelBtn: false,
              success: () => {
                this.uploadGoogleDrive(pageId, link, onStart)
              },
            });
          }else{
            this.uploadGoogleDrive(pageId, link, onStart)
          }
        })
        .catch(() => {
          Popup.alert('エラーが発生しました');
        })
      }
    } else {
      this.finishProgress();
      Popup.alert("URLが入力されていません。", '', '', {kind: 'akaire'});
    }
  };

  getFileIdFromUrl = (url) => {
    const match = url.match(/(?:drive|file)\/d\/([^/]+)/);
    return match ? match[1] : null;
  };


  uploadGoogleDrive = (pageId, link, onStart) => {
    const { limitUploadVideo } = this.props;
    const { animationKind, userChoice } = this.state
    onStart();
    this.setState({ showProgressBar: true });
    const baseApiClient = apiClient({ baseURL: "/akaire_feature/akaires" });
    baseApiClient.get(`/animations/check_drive_link?url=${encodeURIComponent(link)}&animation_kind=${animationKind}`)
    .then(res => {
      // 手本(AnimationUploaderModal)と同一: 200MB超 か 100頁超で開始モーダル
      const _heavyMB = 200 * 1024 * 1024;
      if (res.data && ((res.data.size && res.data.size > _heavyMB) || (res.data.page_count && res.data.page_count > 100))) {
        Popup.confirm(
          `アップロードを開始しました。<br>このPDFのアップロードには時間がかかる場合があります。<br>そのまましばらくお待ちください。`,
          { confirmText: 'OK', cancelBtn: 'false', success: () => {}, kind: 'akaire' }
        )
      }
      const data = {
        url: link, // Already handled by Rails' parameter parsing
        page_id: pageId,
        from_project_id: this.fromProjectId(),
        from_task_id: this.fromTaskId(),
        from_work_id: this.fromWorkId(),
        from_page_id: this.fromPageId(),
        from_akaire_file_id: this.fromAkaireFileId(),
        with_new_task: this.withNewTask(),
        with_new_project: this.withNewProject(),
        animation_kind: animationKind,
        handle_delete: userChoice,
      };
      this.apiClient
      .post(`/animations/save_animation_drive`, data)
      .then((response) => {
        if (response.data.success) {
          setTimeout(() => {
            this.setState({ link: "", completed: 100 });
          }, 1500);
          this.checkUploadStatus(response.data, pageId)
        } else {
          this.finishProgress();
          $("#overVideoURLModal").modal('show');
        }
      })
      .catch(() => {
        Popup.alert("このページにアクセスできません。", '', '', {kind: 'akaire'});
        this.finishProgress();
        this.props.endLoading()
      })
    })
    .catch((data) => {
      this.props.endLoading();
      this.finishProgress();
      this.saveStateToHistory();
      if (data.response.data.error) {
        if (data.response.data.error === 'video_exceeds_allowed_limit') {
          if (limitUploadVideo.is_plan_free_or_light) {
            $('.animation-uploader-modal input').val('');
            Popup.confirm(`1回での動画アップロード上限（${Shared.formatBytes(limitUploadVideo.size)}）<br>を超過した為、アップロードできません。`, {
              cancelBtn: 'false',
              confirmText: 'プランを変更する',
              success: () => { window.open(Routes.owner_total_info_path()) },
              cancel: () => {},
              kind: 'akaire'
            })
          } else {
            Popup.alert(
              `1回での動画アップロード上限（${Shared.formatBytes(limitUploadVideo.size)}）<br>を超過した為、アップロードできません。`
            );
          }
        } else {
          Popup.alert(data.response.data.error, '', '', {kind: 'akaire'});
        }
      } else {
        this.setState({
          shouldShowDriveImageModal: false,
          shouldShowDriveVideoModal: false,
          shouldShowInvalidLink: true,
        });
      }
    })
  }
  submitAssignNewProject = (animationId) => {
    const f = document.createElement('form')
    f.method = 'POST'
    f.action = '/akaire_feature/akaires/assign_animation_to_akaire_page'
    const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i) }
    add('animation_id', animationId)
    add('project_id', 'new')
    add('from_direct', 'true')
    document.body.appendChild(f)
    f.submit()
  }
  submitAssignNewTask = (animationId) => {
    const f = document.createElement('form')
    f.method = 'POST'
    f.action = '/akaire_feature/akaires/assign_animation_to_akaire_page'
    const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i) }
    add('animation_id', animationId)
    add('project_id', this.fromProjectId())
    add('task_id', 'new')
    add('from_direct', 'true')
    document.body.appendChild(f)
    f.submit()
  }
  submitAssignNewFile = (animationId) => {
    const f = document.createElement('form')
    f.method = 'POST'
    f.action = '/akaire_feature/akaires/assign_animation_to_akaire_page'
    const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i) }
    add('animation_id', animationId)
    add('project_id', this.fromProjectId())
    if (this.fromTaskId()) add('task_id', this.fromTaskId())
    add('akaire_file_id', 'new')
    add('from_direct', 'true')
    document.body.appendChild(f)
    f.submit()
  }

  checkUploadStatus = (responseData, pageId) => {
    const { limitUploadPdf, isAkaireFileList } = this.props;

    var id_interval = setInterval(() => {
      this.apiClient.get(`${'/animations/check_google_drive_upload_status'}?animation_id=${responseData.animation_id}`)
        .then((res) => {
          if (res.data.type === 'success') {
            if (res.data.is_wait) {
              setTimeout(() => {
                toastr.success('動画をアップロードしました。');
                clearInterval(id_interval);
                this.finishProgress();
              }, 1000);

              if (!!isAkaireFileList) {
                this.props.onReloadAfterUpdate(pageId, responseData.animation_id)
              } else {
                this.props.onReloadAfterUpdate()
                setTimeout(() => {
                  this.closeModal();
                  if (res.data.akaire_file_id && (this.withNewProject() == 'true' || this.withNewTask() == 'true' || this.withNewFile() == 'true')) {
                    window.location.href = Routes.akaire_feature_akaire_file_path(res.data.akaire_file_id, { page_id: res.data.page_id, animation_id: responseData.animation_id, assign_success: 'assign_success' });
                    return;
                  }
                  if(res.data.page_id) {
                    window.location = window.location.href.split('?')[0].replace('#!', '') + `?update_version_page=${res.data.page_id}&animation_id=${responseData.animation_id}&new_page=${pageId == 'new'}&type=${res.data.file_type}`;
                  } else {
                    if (this.withNewProject() == 'true' && responseData.animation_id) { this.submitAssignNewProject(responseData.animation_id); return; } if (this.withNewTask() == 'true' && responseData.animation_id) { this.submitAssignNewTask(responseData.animation_id); return; } if (this.withNewFile() == 'true' && responseData.animation_id) { this.submitAssignNewFile(responseData.animation_id); return; } window.location.href = Routes.list_temp_file_akaire_feature_akaires_path({upload_status: 'success'})
                  }
                }, 1000);
              }
            } else {
              clearInterval(id_interval);
              this.closeModal();
              this.finishProgress();
              if (!!isAkaireFileList) {
                this.props.onReloadAfterUpdate(pageId, responseData.animation_id)
              } else {
                this.props.onReloadAfterUpdate()
                if (res.data.akaire_file_id && (this.withNewProject() == 'true' || this.withNewTask() == 'true' || this.withNewFile() == 'true')) {
                  window.location.href = Routes.akaire_feature_akaire_file_path(res.data.akaire_file_id, { page_id: res.data.page_id, animation_id: responseData.animation_id, assign_success: 'assign_success' });
                  return;
                }
                if(res.data.page_id) {
                  window.location = window.location.href.split('?')[0].replace('#!', '') + `?update_version_page=${res.data.page_id}&animation_id=${responseData.animation_id}&new_page=${pageId == 'new'}&type=${res.data.file_type}`;
                } else {
                  if (this.withNewProject() == 'true' && responseData.animation_id) { this.submitAssignNewProject(responseData.animation_id); return; } if (this.withNewTask() == 'true' && responseData.animation_id) { this.submitAssignNewTask(responseData.animation_id); return; } if (this.withNewFile() == 'true' && responseData.animation_id) { this.submitAssignNewFile(responseData.animation_id); return; } window.location.href = Routes.list_temp_file_akaire_feature_akaires_path({upload_status: 'success', type: res.data.file_type})
                }
              }
            }
          }
        })
        .catch((res) => {
          const errorData = res.response ? res.response.data : {};
          this.finishProgress();
          if (errorData.message === 'PDF_exceeds_allowed_limit') {
            if (limitUploadPdf.is_plan_free_or_light) {
              Popup.confirm(`1回でのPDFアップロード上限（${Shared.formatBytes(limitUploadPdf.size)}｜${limitUploadPdf.page}頁）<br>を超過した為、アップロードできません。<br>データ圧縮後、再度お試しください。`, {
                cancelBtn: 'false',
                confirmText: 'プランを変更する',
                success: () => { window.open(Routes.owner_total_info_path()) },
                cancel: () => {},
                kind: 'akaire'
              })
            } else {
              Popup.alert(`1回でのPDFアップロード上限（${Shared.formatBytes(limitUploadPdf.size)}｜${limitUploadPdf.page}頁）<br>を超過した為、アップロードできません。<br>データ圧縮後、再度お試しください。`);
            }
          } else {
            Popup.alert('データのアップロードに失敗しました。');
          }
          clearInterval(id_interval);
          this.props.endLoading();
          this.closeModal();
        });
    }, 5000);
  }

  toggleTooltipSpecialPage = () => {
    this.setState({
      tooltipSpecialPageOpen: !this.state.tooltipSpecialPageOpen,
    });
  };

  toggleTooltipLazyPage = () => {
    // if not setTimeout, tooltip on mobile will not hide after open
    // references: https://stackoverflow.com/a/49294377
    setTimeout(() => {
      this.setState({
        tooltipLazyPageOpen: !this.state.tooltipLazyPageOpen,
      });
    }, 0);
  };

  checkGoogleInstruction = () => {
    this.saveStateToHistory();
    this.setState({
      shouldShowGooglePolicy: false,
      shouldShowOriginSelect: false,
      shouldShowGoogleOption: true,
      shouldShowDriveImageModal: false,
      shouldShowDriveVideoModal: false,
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      link: event.target.value
    });
  }

  handleSelectDevice = (value) => {
    let device = deviceOptions.filter((option) => option.value === value);
    device = device.length > 0 ? device[0] : deviceOptions[0];
    this.setState({ deviceSelected: device });
  };

  goBackToSelect = (event) => {
    if (event) event.preventDefault();
    this.stateHistory = [];
    this.setState({
      shouldShowGooglePolicy: false,
      shouldShowOriginSelect: true,
      shouldShowGoogleOption: false,
      shouldShowDriveImageModal: false,
      shouldShowDriveVideoModal: false,
      shouldShowNoPermission: false,
      shouldShowInvalidLink: false,
      shouldShowLimitDriverWithLessProPlan: false,
      animationKind: 'image',
      link: '',
      shouldShowLimitYoutubeModal: false,
    });
  }

  hideGoogleInstruction() {
    apiClient({ baseURL: Routes.hide_popup_google_instruction_owner_users_path() })
      .post()
      .then((response) =>{})
      .catch(() => {
        Popup.alert("このページにアクセスできません。");
      })
  }

  checkShowGoogleInstructionModal = () => {
    if (this.state.googleInstructionOpened) return true;

    apiClient({ baseURL: Routes.check_show_popup_google_instruction_owner_users_path() })
      .post()
      .then((response) =>{
        this.setState({ googleInstructionOpened: response.data })
        return response.data
      })
      .catch(() => {
        Popup.alert("このページにアクセスできません。");
      })
  }

  checkCompanySubscription = () => {
    apiClient({ baseURL: Routes.check_company_google_usage_owner_users_path() })
      .post()
      .then((response) =>{
        this.setState({ shouldShowNoPermission: !response.data })
        if (!response.data) {
          this.finishProgress();
        }
        return !response.data
      })
      .catch(() => {
        Popup.alert("このページにアクセスできません。");
      })
  }

  openPlanHeaderModal = () => {
    const toggleBtn = $('#plan-header-toggle-btn');
    if(toggleBtn && toggleBtn.length > 0) {
      toggleBtn.trigger('click');
    }
    else {
      window.open(Routes.owner_total_info_path());
    }
  }

  renderResponsiveTitle = (firstLine, secondLine) => (
    <span className="capture-url-modal-title">
      <span className="capture-url-modal-title-line">{firstLine}</span>
      <span className="capture-url-modal-title-line">{secondLine}</span>
    </span>
  )

  renderUpgradeNote = (text) => (
    <span className="capture-url-upgrade-note-text">
      <span className="capture-url-upgrade-note-line">{text}</span>
      <span className="capture-url-upgrade-note-line capture-url-upgrade-note-action">
        （<a target="#" className="text-underline text-black font-weight-bold cursor-pointer capture-url-upgrade-link" onClick={() => this.openPlanHeaderModal()}>プランを変更する</a>）
      </span>
    </span>
  )


  render() {
    const { baseURL, projectId, isOpen, onStart, onError, type, onClickInputFile , isUploadMultipleFiles, onClickGoogle, currentPlan, isFreeOrLightPlan} = this.props;
    const { shouldShowOriginSelect, shouldShowGooglePolicy, shouldShowGoogleOption, userChoice, shouldShowNoPermission,
            shouldShowDriveImageModal, shouldShowDriveVideoModal, link, deviceSelected,
            shouldShowInvalidLink, taskType, shouldShowLimitDriverWithLessProPlan, shouldShowLimitYoutubeModal } = this.state
    let googlePolicy = "";
    let driveImage = "";
    let driveVideo = "";
    let googleOption = "";
    const isMobile = window.screen.width < 768;
    const { completed, showProgressBar } = this.state;
    let progressBar = "";
    if (showProgressBar) {
      progressBar = (
        <Progress value={completed} className="mx-2 mt-2">
          {completed}%
        </Progress>
      );
    } else {
      progressBar = "";
    }
    if(shouldShowGooglePolicy) {
      googlePolicy = (
        <GooglePolicyModal
          onCheckboxChange={(event) => this.checkboxChange(event)}
          onUnderstandClick={this.checkGoogleInstruction}
          isMobile={isMobile}
          goBackToSelect={this.goBackToSelect}
        />
      )
    }

    if(shouldShowDriveImageModal) {
      driveImage = (
        <GoogleDriveImageUploader
          onInputChange={(event) => this.handleChange(event)}
          onSelectChange={this.setUserChoice}
          userChoice={userChoice}
          isMobile={isMobile}
        />
      )
    }

    if(shouldShowDriveVideoModal) {
      driveVideo = (
        <GoogleDriveVideoUploader
          onInputChange={(event) => this.handleChange(event)}
          onSelectChange={this.setUserChoice}
          userChoice={userChoice}
          isMobile={isMobile}
        />
      )
    }

    if(shouldShowGoogleOption) {
      googleOption = (
        <GoogleOptionSelector
          onSelectOption={this.handleChooseOrigin}
          isMobile={isMobile}
          taskType={this.state.taskType}
        />
      )
    }
    return (
      <Modal isOpen={isOpen} toggle={this.handleClickOutside} ref={node => (this.modalRef = node)} className={`animation-uploader-modal modal-dialog-centered modal-style additional-akaire ${shouldShowGooglePolicy ? 'policy-content' : ''}`} id={CAPTURE_URL_SELECT_MODAL_ID} onClosed={this.props.onClosed}>
        <div className={`text-center w-100 justify-content-center modal-header ${isMobile ? "position-relative" : ""}`} style={{paddingBottom: '6px'}}>
            {
              shouldShowOriginSelect ? (
                <div className="text-center d-flex justify-content-center align-items-center capture-url-modal-header-row">
                  <img className="create-akaire-box-icon-upload mr-2"
                          src={IconUploadYoutubeDrive} alt="アップロード" width="50" />
                  <p className="text-primary additional-akaire-title font-weight-bold mb-0">
                    {this.renderResponsiveTitle('オンラインコンテンツを', '校正する')}
                  </p>
                </div>
              ) : (
                <React.Fragment>
                  {
                    isMobile ? (
                      <div className="text-center d-flex justify-content-center align-items-center capture-url-modal-header-row">
                        <img className="create-akaire-box-icon-upload mr-2"
                                src={IconGDrive} alt="アップロード" width="36px" height="28px" />
                        <p className="text-primary additional-akaire-title font-weight-bold mb-0">
                          {this.renderResponsiveTitle('Googleドライブのデータを', '校正する')}
                        </p>
                      </div>
                    ) : (
                      <div className="text-center d-flex justify-content-center align-items-center capture-url-modal-header-row">
                        <img className="create-akaire-box-icon-upload mr-2"
                                src={IconGDrive} alt="アップロード" width="50" height="38"/>
                        <p className="text-primary additional-akaire-title font-weight-bold mb-0">
                          {this.renderResponsiveTitle('Googleドライブのデータを', '校正する')}
                        </p>
                      </div>
                    )
                  }
                </React.Fragment>
              )
            }
          </div>

        {
          (shouldShowNoPermission || shouldShowInvalidLink) ? (
            <div className={`${isMobile ? "error-mobile-box" : "error-box" } text-black`}>
              {
                shouldShowInvalidLink && (
                  <React.Fragment>
                    {
                      isMobile ? (
                        <div className='d-flex mt-4' style={{flexDirection: "column", fontSize: '13px'}}>
                          <b className="d-flex justify-content-center">このURLは校正対象外です。</b>
                          <div className ='mt-2' style={{marginLeft: '10%', fontSize: '13px', marginRight: '10%'}}>
                            <span className="">共有設定が「リンクを知っている全員」以外、</span>
                            <span className="">または校正対象外の形式のURLが入力されている可能性があります。</span>
                            <span className="">共有設定と形式をご確認ください。</span>
                            <br/>
                            <br/>
                            <span className="">Googleドライブの各ファイルの右側にある「共有」メニューから、</span>
                            <span className="">一般的なアクセス権を「リンクを知っている全員」に設定してください。</span>
                            <br/>
                            <br/>
                            <span className="">さらに、歯車アイコンをクリックし、「閲覧者および閲覧者（コメント可）に対して、</span>
                            <span className="">ダウンロード、印刷、コピーのオプションを表示する」にチェックを入れる必要があります。</span>
                            <br/>
                          </div>
                        </div>
                      ) : (
                        <React.Fragment>
                          <b className='d-flex justify-content-center'>このURLは校正対象外です。</b>
                          <div className='mt-2' style={{marginLeft: '5%', fontSize: '14px'}}>
                            <span>共有設定が「リンクを知っている全員」以外、</span> <br/>
                            <span>または校正対象外の形式のURLが入力されている可能性があります。</span> <br/>
                            <span style={{marginBottom: '12px'}}>共有設定と形式をご確認ください。</span> <br/>
                            <span>Googleドライブの各ファイルの右側にある「共有」メニューから、</span> <br/>
                            <span style={{marginBottom: '12px'}}>一般的なアクセス権を「リンクを知っている全員」に設定してください。</span> <br/>
                            <span>さらに、歯車アイコンをクリックし、「閲覧者および閲覧者（コメント可）に対して、</span> <br/>
                            <span>ダウンロード、印刷、コピーのオプションを表示する」にチェックを入れる必要があります。</span> <br/>
                          </div>
                        </React.Fragment>
                      )
                    }
                  </React.Fragment>
                )
              }
            </div>
          ) : (
            <form onSubmit={ (event) =>  { event.preventDefault(); this.handleSubmit(event) } }>
                {progressBar}
                <ModalBody
                  onProgress={this.onCaptureProgress}
                  className="py-0 bg-white mt-3"
                >
                  {
                    shouldShowOriginSelect && (
                      <div className="mt-3 create-akaire-box align-center-div capture-url-origin-select">
                        <span className='additional-akaire-title-block'> 下記より、校正するオンラインコンテンツを選択してください。</span>
                        <NavLink href="#" className={`create-akaire-box-link cursor-pointer text-black`} onClick={(event) => {this.handleChooseOrigin(event, 'youtube')}} style={{fontWeight: 'normal'}}>
                          <span className='link-dot'>•</span>YouTube動画を校正する
                        </NavLink>
                        <div className='d-flex text-red'>
                          <NavLink href="#" className={`create-akaire-box-link cursor-pointer text-black`} onClick={(event) =>{this.handleChooseOrigin(event, 'google')}} style={{fontWeight: 'normal'}}>
                            <span className='link-dot'>•</span>Googleドライブのデータを校正する
                          </NavLink>
                        </div>
                        {isFreeOrLightPlan && (
                          <p style={{color: '#6E6E6E', opacity: '1'}} className="text-upgrade-plan capture-url-upgrade-note mt-3 mb-0">
                            {isMobile ? this.renderUpgradeNote('※YouTubeは、Standardプランよりご利用できます。') : <>※YouTubeは、Standardプランよりご利用できます。（<a target="#" className="text-underline text-black font-weight-bold cursor-pointer capture-url-upgrade-link" onClick={() => this.openPlanHeaderModal()}>プランを変更する</a>）</>}
                          </p>
                        )}
                        {(isFreeOrLightPlan || currentPlan === 'Standard') && (
                          <p style={{color: '#6E6E6E', opacity: '1'}} className="text-upgrade-plan capture-url-upgrade-note mb-0">
                            {isMobile ? this.renderUpgradeNote('※Googleドライブは、Proプランよりご利用できます。') : <>※Googleドライブは、Proプランよりご利用できます。（<a target="#" className="text-underline text-black font-weight-bold cursor-pointer capture-url-upgrade-link" onClick={() => this.openPlanHeaderModal()}>プランを変更する</a>）</>}
                          </p>
                        )}
                      </div>
                    )
                  }
                  { googleOption }
                  { driveImage }
                  { driveVideo }
                  { googlePolicy }
                </ModalBody>
              </form>
            )
        }
        <LimitDriverWithLessProPlan isOpen={shouldShowLimitDriverWithLessProPlan} onClickClose={() => this.setState({shouldShowLimitDriverWithLessProPlan: false})} currentPlan={currentPlan} />
        <LimitYoutubeModal isOpen={shouldShowLimitYoutubeModal} onClickClose={() => this.setState({shouldShowLimitYoutubeModal: false})} currentPlan={currentPlan} />
      </Modal>
    );
  }
};
